import { render, staticRenderFns } from "./span_tile.vue?vue&type=template&id=8f89c8d8&"
import script from "./span_tile.vue?vue&type=script&lang=js&"
export * from "./span_tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports